import React from "react";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";

// 定义搜索项配置接口
interface SearchItemConfig {
  name: string;
  label: string;
  type: "input" | "select" | "date" | "dateRange" | "number" | "inputNumber";
  placeholder?: string;
  options?: Array<{ value: string | number; label: string }>;
  props?: any;
  colSpan?: number;
}

// 管理员搜索配置
export const adminSearchConfig: SearchItemConfig[] = [
  {
    name: "admin_account",
    label: "管理员账号",
    type: "input",
    placeholder: "请输入管理员账号",
    colSpan: 6,
  },
  {
    name: "admin_phone",
    label: "手机号",
    type: "input",
    placeholder: "请输入手机号",
    colSpan: 6,
  },
  {
    name: "account_status",
    label: "账号状态",
    type: "select",
    placeholder: "请选择账号状态",
    options: [
      { value: "", label: "全部" },
      { value: 0, label: "待激活" },
      { value: 1, label: "正常" },
      { value: 2, label: "禁用" },
    ],
    colSpan: 6,
  },
  {
    name: "is_super_admin",
    label: "管理员类型",
    type: "select",
    placeholder: "请选择管理员类型",
    options: [
      { value: "", label: "全部" },
      { value: "true", label: "超级管理员" },
      { value: "false", label: "普通管理员" },
    ],
    colSpan: 6,
  },
  {
    name: "role_name",
    label: "所属角色",
    type: "select",
    placeholder: "请选择角色",
    options: [], // 将在组件中动态加载
    colSpan: 6,
  },
  {
    name: "created_date_range",
    label: "创建时间",
    type: "dateRange",
    placeholder: "请选择创建时间范围",
    colSpan: 6,
  },
  {
    name: "last_login_date_range",
    label: "最后登录时间",
    type: "dateRange",
    placeholder: "请选择最后登录时间范围",
    colSpan: 6,
  },
];

// 搜索组件配置
export const searchConfig = {
  title: "管理员搜索",
  columns: 4,
  collapsible: true,
  defaultCollapsed: true,
};

// 标题栏按钮配置（用于 ContainerPanel.buttons）
export const getSearchPanelButtons = (
  handleReset: () => void,
  handleSearch: (values?: any) => void,
  getValues?: () => any
) => [
    {
      key: "reset",
      text: "重置",
      type: "default" as const,
      icon: React.createElement(ReloadOutlined),
      onClick: handleReset,
      group: "primary" as const,
    },
    {
      key: "search",
      text: "搜索",
      type: "primary" as const,
      icon: React.createElement(SearchOutlined),
      onClick: (): void => {
        const values = typeof getValues === "function" ? getValues() : undefined;
        handleSearch(values);
      },
      group: "primary" as const,
    },
  ];
